
import React, { Component } from "react";

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

//3 party Libs
import moment from 'moment';

//material ui components
import Grid from '@material-ui/core/Grid'

//Actions
import { AddViewWorkOrder, getAllRepairs } from '../../actions/repairAction'

class RepairDetails extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            repairSelectedForDetails: props.repairSelectedForDetails ? props.repairSelectedForDetails : undefined,
            repairSelectedForDetailsStatus: props.repairSelectedForDetailsStatus ? props.repairSelectedForDetailsStatus : undefined,
            //Repairs
            repairs: undefined,
            //rootFontSize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
        };
    }

    async componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        const repairId = (this.state.repairSelectedForDetails && this.state.repairSelectedForDetails._id) ? this.state.repairSelectedForDetails._id : undefined;
        const profileKeyCloakObj = localStorage.getItem('ky') ? JSON.parse(localStorage.getItem('ky')) : undefined;
        let profileObject = (profileKeyCloakObj && profileKeyCloakObj.profile) ? profileKeyCloakObj.profile : undefined;
        let viewByName = (profileObject && profileObject.username) ? profileObject.username : undefined;
        let viewByObj = {
            userName: viewByName,
            pictureUrl: ''
        }

        if (viewByObj && repairId) {
            const res = await this.props.AddViewWorkOrder(repairId, viewByObj);

            if(res && res.ok && this.props.onAddView){
                this.props.onAddView()
            }
        }

        if (localStorage.getItem('superAdmin') === "false" || (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0)) {

            //this.getRepairs(600);
        }

        setTimeout(() => {
            if (this.state.repairSelectedForDetails && this.props.tableData) {

                const idRepairSelected = this.state.repairSelectedForDetails._id;
                const repairWithSelectedRepairId = this.props.tableData.find(repair => repair._id === idRepairSelected);

                if (repairWithSelectedRepairId) {
                    this.setState({ repairSelectedForDetails: repairWithSelectedRepairId });
                }
            }
        }, 700);

    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    getRepairs = (time = 0) => {
        setTimeout(() => {

            this.props.getAllRepairs(localStorage.getItem('communityId'));
        }, time);
    };


    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }

    GetResponseTime = (createdDate, repairDate) => {
        let cDate = new Date(createdDate);
        let rDate = new Date(repairDate);

        if (cDate && rDate) {
            cDate = cDate.getTime();
            rDate = rDate.getTime();
        }

        let seconds = Math.floor(Math.abs(cDate - rDate) / 1000);
        let days = 0;
        let hours = 0;
        let minutes = 0;

        let repairTimeString = '';

        if (seconds >= 86400) {
            days = Math.floor(seconds / 86400);
            seconds = seconds - (86400 * days);
            repairTimeString = days + ' d ';
        }

        if (seconds >= 3600) {
            hours = Math.floor(seconds / 3600);
            seconds = seconds - (hours * 3600);
            repairTimeString += hours + ' hr ';
        }

        if (seconds >= 60) {
            minutes = Math.floor(seconds / 60);
            seconds = seconds - (minutes * 60);
            repairTimeString += minutes + ' min ';
        }

        return repairTimeString;
    };

    GetTimeLapse = (repairDate, closedDate) => {
        let rDate = new Date(repairDate);
        let cDate = new Date(closedDate);

        let seconds = Math.floor(Math.abs(cDate - rDate) / 1000);
        let days = 0;
        let hours = 0;
        let minutes = 0;

        let repairTimeString = '';

        if (seconds > 60) {
            if (seconds >= 86400) {
                days = Math.floor(seconds / 86400);
                seconds = seconds - (86400 * days);
                repairTimeString = days + ' d ';
            }

            if (seconds >= 3600) {
                hours = Math.floor(seconds / 3600);
                seconds = seconds - (hours * 3600);
                repairTimeString += hours + ' hr ';
            }

            if (seconds >= 60) {
                minutes = Math.floor(seconds / 60);
                seconds = seconds - (minutes * 60);
                repairTimeString += minutes + ' min ';
            }
        }
        else {
            repairTimeString = '< 1 min ';
        }


        return repairTimeString + 'ago';
    };

    GetDiffMin = (startDate, endDate) => {
        const sDate = new Date(startDate);
        const eDate = new Date(endDate);

        return Math.floor(Math.abs(sDate - eDate) / (1000 * 60))
    }

    CalculateLeftProperty = (actions) => {
        const closedDate = actions.find(action => action.title === 'Closed');
        const cancelDate = actions.find(action => action.title === 'canceled');
        const startDate = (actions && actions.length > 0) ? moment(actions[0].timeLineDate) : moment(new Date());
        const endDate = closedDate ? moment(closedDate.timeLineDate) : cancelDate ? moment(cancelDate.timeLineDate) : moment(new Date());

        actions.forEach(action => {
            let minToEnd = this.GetDiffMin(startDate, endDate);
            const minToAction = this.GetDiffMin(startDate, action.timeLineDate);

            let actionLeft = action.order ? (minToAction * 100 / minToEnd) : 0;
            actionLeft = actionLeft > 100 ? 100 : actionLeft;

            action.actionLeft = actionLeft;
        });

        if (actions.length > 0) {

            let avgPercentage = 0;
            actions.forEach(
                action => {
                    avgPercentage = avgPercentage + action.actionLeft;
                }
            );
            avgPercentage = avgPercentage / actions.length;


            this.ChangeLeftPropertyInActions(actions);

            // if(avgPercentage <= 50){              
            //     if(actions.length >= 2){
            //         // Even Numbers
            //         for(let i = 0; i < actions.length -2; i = i+2){
            //             for(let j = i+2 ; j <= actions.length-1; j = j+2){

            //                 let action= actions[i];
            //                 let nextAction = actions[j];

            //                 const diff = Math.abs(action.actionLeft - nextAction.actionLeft)
            //                 if( diff < 10){

            //                     nextAction.actionLeft = nextAction.actionLeft +(10 - diff);

            //                     if(nextAction.actionLeft >100){
            //                         nextAction.actionLeft =100;
            //                     } else if(nextAction.actionLeft <0){
            //                         nextAction.actionLeft =0;
            //                     }
            //                 }
            //             }                        
            //         }

            //         //Odd Numbers
            //         for(let i = 1; i < actions.length -2; i = i+2){
            //             for(let j = i+2 ; j <= actions.length-1; j = j+2){

            //                 let action= actions[i];
            //                 let nextAction = actions[j];

            //                 const diff = Math.abs(action.actionLeft - nextAction.actionLeft)
            //                 if( diff < 10){

            //                     nextAction.actionLeft = nextAction.actionLeft +(10 - diff);

            //                     if(nextAction.actionLeft >100){
            //                         nextAction.actionLeft =100;
            //                     } else if(nextAction.actionLeft <0){
            //                         nextAction.actionLeft =0;
            //                     }
            //                 }
            //             }                        
            //         }
            //     }
            // }
            // else{
            //     if(actions.length >= 2){
            //         //Even Numbers
            //         for(let i = actions.length -1; i > 0; i = i-2){
            //             for(let j = i-1 ; j >= 0; j = j-2){

            //                 let action= actions[i];
            //                 let nextAction = actions[j];

            //                 const diff = Math.abs(action.actionLeft - nextAction.actionLeft);
            //                 if( diff < 10){

            //                     nextAction.actionLeft = nextAction.actionLeft -(10 - diff);

            //                     if(nextAction.actionLeft >100){
            //                         nextAction.actionLeft =100;
            //                     } else if(nextAction.actionLeft <0){
            //                         nextAction.actionLeft =0;
            //                     }
            //                 }
            //             }

            //         }

            //         //Odd Numbers
            //         for(let i = actions.length -2; i > 0; i = i-2){
            //             for(let j = i-1 ; j >= 0; j = j-2){

            //                 let action= actions[i];
            //                 let nextAction = actions[j];

            //                 const diff = Math.abs(action.actionLeft - nextAction.actionLeft);
            //                 if( diff < 10){

            //                     nextAction.actionLeft = nextAction.actionLeft -(10 - diff);

            //                     if(nextAction.actionLeft >100){
            //                         nextAction.actionLeft =100;
            //                     } else if(nextAction.actionLeft <0){
            //                         nextAction.actionLeft =0;
            //                     }
            //                 }
            //             }

            //         }
            //     }
            // }


        }

    }


    ChangeLeftPropertyInActions = (actions) => {

        const diffLimit = 10;
        //actions 0-49
        const actionsFirstHalf = actions.filter(action => action.actionLeft < 50);


        if (actionsFirstHalf.length >= 2) {

            //Even
            for (let i = 0; i < actionsFirstHalf.length; i = i + 2) {
                for (let j = i + 2; j < actionsFirstHalf.length; j = j + 2) {

                    const action = actionsFirstHalf[i];
                    const nextAction = actionsFirstHalf[j];

                    const actionLeftDiff = Math.abs(nextAction.actionLeft - action.actionLeft);

                    if (actionLeftDiff < diffLimit) {
                        nextAction.actionLeft = nextAction.actionLeft + (diffLimit - actionLeftDiff) + 6;
                    }
                }
            }

            //Odd
            for (let i = 1; i < actionsFirstHalf.length; i = i + 2) {
                for (let j = i + 2; j < actionsFirstHalf.length; j = j + 2) {

                    const action = actionsFirstHalf[i];
                    const nextAction = actionsFirstHalf[j];

                    const actionLeftDiff = Math.abs(nextAction.actionLeft - action.actionLeft);

                    if (actionLeftDiff < diffLimit) {
                        nextAction.actionLeft = nextAction.actionLeft + (diffLimit - actionLeftDiff) + 6;
                    }
                }
            }
        }

        // actions 50-100
        const actionsSecondHalf = actions.filter(action => action.actionLeft >= 50);

        if (actionsSecondHalf.length >= 2) {

            //Even
            for (let i = actionsSecondHalf.length - 1; i >= 0; i = i - 2) {
                for (let j = i - 2; j >= 0; j = j - 2) {

                    const action = actionsSecondHalf[i];
                    const nextAction = actionsSecondHalf[j];

                    const actionLeftDiff = Math.abs(nextAction.actionLeft - action.actionLeft);

                    if (actionLeftDiff < diffLimit) {
                        nextAction.actionLeft = nextAction.actionLeft - (diffLimit - actionLeftDiff);
                    }
                }
            }

            //Odd
            for (let i = actionsSecondHalf.length - 2; i >= 0; i = i - 2) {
                for (let j = i - 2; j >= 0; j = j - 2) {

                    const action = actionsSecondHalf[i];
                    const nextAction = actionsSecondHalf[j];

                    const actionLeftDiff = Math.abs(nextAction.actionLeft - action.actionLeft);

                    if (actionLeftDiff < diffLimit) {
                        nextAction.actionLeft = nextAction.actionLeft - (diffLimit - actionLeftDiff);
                    }
                }
            }
        }
    }
    //#endregion

    //#region Inner Components
    RenderInnerResidentComponent = ({ resident, isCommonArea }) => {

        const pictureUrl = (resident && resident.residentPictureUrl) ? resident.residentPictureUrl : '';
        const residentName = (resident && resident.name) ? resident.name : '';
        const residentLastName =(resident && resident.lastName) ? resident.lastName : '';
        const initialFirstName =(residentName && residentName.length >0)?residentName.slice().charAt(0).toUpperCase():  '';
        const initialLastName = (residentLastName && residentLastName.length > 0)? residentLastName.slice().charAt(0).toUpperCase(): '';

        const initials = (isCommonArea)? 'N/A':   `${initialLastName}${initialFirstName}`;

        return (
            <Grid item container xs={12} className="alingCenter" id='repair_details_resident'>
                <Grid item container xs={12} className="alingCenter">
                    <Grid item xs={12} className="RepairSectionTitles">Resident</Grid>
                </Grid>
                <Grid item container xs={12} className="MarginTop alingCenter">
                    <Grid item container xs={12} className="RepairsGrid alingCenter" direction='column' justify="space-evenly">
                        <Grid item>
                            {
                                pictureUrl !== '' && pictureUrl !== 'https://engage360.s3.amazonaws.com/Residents/profile.png' ?
                                    <img
                                        className="RepairsResidentImage"
                                        src={pictureUrl}
                                        alt={residentName}
                                    />
                                    :
                                    <Grid item className="RepairsResidentImage">
                                        {initials}
                                    </Grid>
                            }

                        </Grid>
                        <Grid item className="RepairsResidentName">{resident.lastName? resident.lastName + ', ' + residentName : ''}</Grid>
                    </Grid>

                </Grid>
            </Grid>
        );
    };

    RenderInnerLocationComponent = ({ item }) => {
        const room = (item && item.room) ? item.room : { name: '' };
        let roomName = room.name.split(' ');
        const firstName = (roomName[0] && roomName[0].length > 0) ? roomName[0].substring(0, 1) : '';
        const lastName = (roomName[1] && roomName[1].length > 0) ? roomName[1].substring(0, 1).toUpperCase() : roomName[0].substring(1, 2).toUpperCase();

        const inital = firstName + lastName;

        return (
            <Grid item container xs={12} className="alignCenter" id='repair_details_location'>
                <Grid item container xs={12} className="alignCenter">
                    <Grid item xs={12} className="RepairSectionTitles">Location</Grid>
                </Grid>
                <Grid item container xs={12} className="MarginTop alignCenter">
                    <Grid item container xs={12} className="RepairsGrid" alignItems='center' direction='column' justify='space-evenly'>
                        <Grid item container justify='center' alignItems='center' className="LocationImage">
                            {
                                <Grid item className="RepairsResidentImage">
                                    {inital}
                                </Grid>
                            }
                        </Grid>
                        <Grid item className="RepairsResidentName">{room.name}</Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderInnerRepairRequestComponent = ({ item }) => {

        return (
            <Grid item container xs={12} className="alignCenter" id='repair_details_repair_requested'>
                <Grid item container xs={12} className="alignCenter">
                    <Grid item xs={12} className="RepairSectionTitles">Repair Requested</Grid>
                </Grid>
                <Grid item container xs={12} className='MarginTop alignCenter'>
                    <Grid item container xs={12} className="RepairsGrid alignCenter" style={{ padding: '20px' }}>
                        <Grid item container xs={12} style={{ height: '30%' }} justify='center' alignItems='center'>
                            <Grid item xs={3} className="RepairRequestedTitles">Item</Grid>
                            <Grid item xs={4} className="RepairRequestedTitles">Issue</Grid>
                            <Grid item xs={5} className="RepairRequestedTitles">Status</Grid>
                        </Grid>
                        <Grid item container xs={12} style={{ height: '50%' }} justify='center' alignItems='flex-start'>
                            <Grid item xs={3}>
                                <this.RenderitemComponnet item={item} />
                            </Grid>
                            <Grid item xs={4} className="issueNameStyle">
                                {(item.issue && item.issue.name) ? item.issue.name : ''}
                            </Grid>
                            <Grid item xs={5} >
                                <this.RenderStatusResponseComponent item={item} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderitemComponnet = ({ item }) => {
        let itemName = item.item ? item.item.name : '';
        const itemIconUrl = item.item.iconUrl ? item.item.iconUrl : ''

        if (itemName) {
            itemName = itemName.charAt(0).toUpperCase() + itemName.slice(1);
        }

        return (
            <Grid item container direction='column' justify='center' alignContent='center'>
                <Grid item style={{ textAlign: 'center' }}>
                    <img alt={'icon Item ' + itemName} src={itemIconUrl} className="itemStyle" />
                </Grid>
                <Grid item className="itemNameStyle">
                    {itemName}
                </Grid>
            </Grid>
        )
    };

    RenderStatusResponseComponent = ({ item, status }) => {
        const itemStatus = item.orderStatus ? item.orderStatus : undefined;
        const createdDate = item.createdDate ? item.createdDate : undefined;
        const scheduleDate = item.timeLine ? item.timeLine.find(item => item.title === 'Scheduled Date') : undefined;
        const canceledDate = item.timeLine ? item.timeLine.find(item => item.title === 'canceled') : undefined;
        const closedDate = item.repairDate ? item.repairDate : undefined;
        const today = new Date();
        const responseTime = (item.orderStatus === 'completed' && item.createdDate && item.repairDate) ? this.GetResponseTime(item.createdDate, item.repairDate) : 'N/A';

        let beforeYesterday = true;

        if (today && createdDate) {
            beforeYesterday = moment(today).subtract(1, 'day') >= moment(createdDate);
        }

        return (
            <Grid item container xs={12}>
                {
                    (item.orderStatus === 'pending' || item.orderStatus === 'completed' || item.orderStatus === 'canceled' || item.orderStatus === 'scheduled') ?
                        <Grid item container direction='column' justify='center' alignItems='center'>
                            <Grid item className="ResponseStatus" style={closedDate ? { color: '#5ad884' } : canceledDate ? { color: '#DB5B70' } : scheduleDate ? { color: '#048ec5' } : beforeYesterday ? { color: '#ac4c5c' } : { color: 'white' }}>
                                {
                                    itemStatus === 'completed' ?
                                        'Closed'
                                        :
                                        (itemStatus === 'pending' && !scheduleDate) ?
                                            'Opened'
                                            :
                                            ((itemStatus === 'pending' || itemStatus === 'scheduled') && scheduleDate) ?
                                                'Scheduled for'
                                                :
                                                'Canceled'
                                }
                            </Grid>
                            <Grid item className="ResponseTime">
                                {
                                    itemStatus === 'completed' ?
                                        closedDate ?
                                            moment(new Date(closedDate)).format('M/D hh:mm A')
                                            :
                                            'N/A'
                                        :
                                        (itemStatus === 'pending' && !scheduleDate) ?
                                            createdDate ?
                                                moment(new Date(createdDate)).format('M/D hh:mm A')
                                                :
                                                'N/A'
                                            :
                                            ((itemStatus === 'pending' || itemStatus === 'scheduled') && scheduleDate) ?
                                                scheduleDate ?
                                                    moment(scheduleDate.timeLineDate).format('M/D hh:mm A')
                                                    :
                                                    'N/A'
                                                :
                                                'N/A'
                                }
                            </Grid>
                        </Grid>
                        :
                        responseTime ?
                            <Grid item container justify='center' alignItems='center'>
                                <Grid item className="ResponseTime">{responseTime}</Grid>
                            </Grid>
                            :
                            <Grid className="ResponseTime">{'N/A'}</Grid>
                }
            </Grid>
        )
    };

    RenderInnerTimeLineComponent = ({ item }) => {
        const acctionHeight = 310;
        const scheduleDate = item.timeLine ? item.timeLine.find(action => action.title === 'Scheduled Date') : undefined;
        const shouldShowScheduleDateInTimeLine = (scheduleDate && scheduleDate.timeLineDate && new Date(scheduleDate.timeLineDate) <= new Date()) ? true : false;


        const styles = {
            title: {
                colorr: '#a5a4a5',
            },
            grid: {
                backgroundColor: '#1f1f1f',
                borderRadius: '16px',
                color: 'white',
                minHeight: acctionHeight + 50 + 'px',
                overflow: 'hidden',
                padding: '15px'
            },
            img: {
                width: '100px',
                height: '100px',
                borderRadius: '50%',
            },
            timeLineContainer: {
                height: acctionHeight + 'px',
                marginLeft: '60px',
                position: 'relative',

            },
            centerLine: {
                height: '2px',
                backgroundColor: '#949393',
                width: '100%',
            },
            now: {
                position: 'absolute',
                right: '-60px',
            },
        };

        return (
            <Grid item container xs={12} justify='center' alignItems='center' id='repair_details_timeline'>
                <Grid item container xs={12} justify='center' alignItems='center'>
                    <Grid item xs={12} className="RepairSectionTitles">Timeline</Grid>
                </Grid>
                <Grid item container xs={12} justify='center' alignItems='center' className="MarginTop">
                    <Grid item container xs={12} style={{ ...styles.grid }} justify='flex-start' alignItems='center' >
                        <Grid item container xs={shouldShowScheduleDateInTimeLine ? 12 : 10} justify='flex-start' alignItems='center' >
                            <Grid item container xs={10} justify='flex-start' alignItems='center' style={{ ...styles.timeLineContainer, }}>
                                <Grid item xs={12} style={{ ...styles.centerLine }}>
                                </Grid>
                                <this.RenderTimeLineAcctions item={item} acctionHeight={acctionHeight} shouldShowScheduleDateInTimeLine={shouldShowScheduleDateInTimeLine} />
                            </Grid>
                            {
                                !item.repairDate && item.orderStatus !== 'canceled' ?
                                    <Grid item xs={1} className="Now">Now</Grid>
                                    :
                                    undefined
                            }
                        </Grid>
                        {
                            !shouldShowScheduleDateInTimeLine && scheduleDate ?
                                <Grid item container xs={2} justify='center' alignItems='center' style={{ color: '#929191', fontSize: '1rem' }}>
                                    <Grid item xs={12} className="Now">Scheduled Date</Grid>
                                    <Grid item xs={12} className="RepairsScheduledHour">{(scheduleDate && scheduleDate.timeLineDate) ? moment(scheduleDate.timeLineDate).format('M/D h:mm A') : moment(new Date()).format('M/D h:mm A')}</Grid>
                                </Grid>

                                :
                                undefined
                        }
                    </Grid>
                </Grid>
            </Grid>
        );

    };

    RenderTimeLineAcctions = ({ item, acctionHeight }) => {
        const styles = {
            acctionsContainer: {
                top: 0,
                left: 0,
                position: 'absolute',
                height: '100%',
            },
        };

        let actionsTimeLine = item.timeLine ? [...item.timeLine] : undefined;
        //actionsTimeLine.push({order:0,title:'Created Date',name:'createdDate',timeLineDate:item.createdDate});

        // if(item.repairDate && actionsTimeLine){
        //     let maxOrder =-1;
        //     actionsTimeLine.forEach(action => {
        //         if(action.order > maxOrder){
        //             maxOrder = action.order;
        //         }
        //     });

        //     actionsTimeLine.push({order:maxOrder+1,title:'Closed Date',name:'closedDate',timeLineDate:item.repairDate});
        // }

        actionsTimeLine = actionsTimeLine.sort((a, b) => moment(a.timeLineDate) >= moment(b.timeLineDate) ? 1 : -1);
        let i = 0;
        actionsTimeLine.forEach(action => {
            action.order = i;
            i++;
        })

        this.CalculateLeftProperty(actionsTimeLine);

        const openAction = actionsTimeLine.find(action => action.title === 'Opened');
        const ClosedAction = actionsTimeLine.find(action => action.title === 'Closed');
        // const CanceledAction=actionsTimeLine.find(action=>action.title=='canceled');
        const ScheduleDateAction = actionsTimeLine.find(action => action.title === 'Scheduled Date');
        const startDate = (openAction && openAction.timeLineDate) ? openAction.timeLineDate : new Date();
        const endDate = item.repairDate ? new Date(item.repairDate) : new Date();
        const closedDate = ClosedAction && ClosedAction.timeLineDate.length > 0 ? ClosedAction.timeLineDate : new Date();
        // const canceledDate = CanceledAction && CanceledAction.timeLineDate.length > 0 ? CanceledAction.timeLineDate : new Date();

        if (ScheduleDateAction &&
            (
                ClosedAction ? closedDate <= new Date(ScheduleDateAction.timeLineDate) :
                    // CanceledAction? canceledDate <=  new Date(ScheduleDateAction.timeLineDate) :
                    new Date() <= new Date(ScheduleDateAction.timeLineDate)
            )
        ) {
            actionsTimeLine = actionsTimeLine.filter(action => action.title !== 'Scheduled Date')
        }


        return (
            <Grid item container alignItems='center' style={{ ...styles.acctionsContainer, }}>
                {
                    (actionsTimeLine && actionsTimeLine.length > 0) ?
                        actionsTimeLine.map(
                            (action,index) => {
                                return (
                                    <Grid item container xs={12} key={`action_${index}`}>
                                        {
                                            this.GetAction(action, startDate, endDate, closedDate)
                                        }
                                    </Grid>
                                )
                            }
                        )
                        : undefined

                }
            </Grid>
        );
    }

    GetAction = (action, startDate, endDate, closedDate) => {


        const styles = {
            action: {
                position: 'absolute',
                border: '1px solid #949393',
                height: '50%',
                width: '1px',
                left: (action.actionLeft ? action.actionLeft : 0) + '%',
            },
            top: {
                top: 0,
            },
            bottom: {
                bottom: 0
            },
            topActionComponent: {
                top: -1,
            },
            bottomActionComponent: {
                bottom: -1,
            },
            actionComponent: {
                position: 'absolute',
                left: '-50px',
                width: '150px',
                minHeight: '30px',
                color: 'white',
                backgroundColor: '#1f1f1f'
            }
        };

        return (
            <Grid item container xs={12}>
                <Grid item container style={(action && action.order % 2 === 0) ? { ...styles.action, ...styles.top } : { ...styles.action, ...styles.bottom }}>
                    <Grid item container style={{ position: 'relative' }} >
                        <Grid item container style={(action && action.order % 2 === 0) ? { ...styles.actionComponent, ...styles.topActionComponent } : { ...styles.actionComponent, ...styles.bottomActionComponent }}>
                            <this.RenderAction action={action} createdDate={startDate} repairDate={endDate} closedDate={closedDate} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderAction = ({ action }) => {
        //this.GetTimeLapse( action.timeLineDate, closedDate)
        let component = <Grid></Grid>;

        switch (action.title) {
            case 'Opened':
                component =
                    <Grid item container style={{ paddingTop: '1rem' }}>
                        <Grid item xs={12} className="RepairActionTitle">Opened</Grid>
                        <Grid item xs={12} className="RepairActionContent" style={{ textAlign: 'left' }}>
                            {
                                (action && action.timeLineDate) ?
                                    moment(action.timeLineDate).format('M/D h:mm A')
                                    :
                                    undefined
                            }
                        </Grid>
                    </Grid>
                break;
            case 'Viewed By':
                component =
                    <Grid item container justify='center' alignItems='center' style={{ paddingTop: '1rem' }}>
                        <Grid item xs={12} className="RepairActionSubTitle">{'Viewed by'}</Grid>
                        <Grid item container xs={12} className="RepairActionContent" justify='flex-start' alignItems='center' >
                            <Grid item xs={4} style={{}}>
                                <img
                                    className="RepairsActionImage"
                                    src='https://engage360.s3.amazonaws.com/Residents/profile.png'
                                    alt={action.userName + ' profile picture'}
                                />
                            </Grid>
                            <Grid item xs={7} style={{}}>{action.userName}</Grid>
                        </Grid>
                        <Grid item xs={12} className="RepairActionContent">
                            {
                                (action && action.timeLineDate) ?
                                    moment(action.timeLineDate).format('M/D h:mm A')
                                    :
                                    undefined

                            }
                        </Grid>
                    </Grid>
                break;
            case 'Scheduled By':
                component =
                    <Grid item container justify='center' alignItems='center' style={{ paddingTop: '1rem' }}>
                        <Grid item xs={12} className="RepairActionSubTitle">{'Scheduled by'}</Grid>
                        <Grid item container xs={12} className="RepairActionContent" justify='flex-start' alignItems='center' >
                            <Grid item xs={4} style={{}}>
                                <img
                                    className="RepairsActionImage"
                                    src='https://engage360.s3.amazonaws.com/Residents/profile.png'
                                    alt={action.userName + ' profile picture'}
                                />
                            </Grid>
                            <Grid item xs={7} style={{}}>{action.userName}</Grid>
                        </Grid>
                        <Grid item xs={12} className="RepairActionContent">
                            {
                                (action && action.timeLineDate) ?
                                    moment(action.timeLineDate).format('M/D h:mm A')
                                    :
                                    undefined
                            }
                        </Grid>
                    </Grid>
                break;
            case 'Scheduled Date':
                component =
                    <Grid item container justify='center' alignItems='center' style={{ paddingTop: '1rem' }}>
                        <Grid item xs={12} className="RepairActionSubTitle">{'Scheduled Date'}</Grid>
                        <Grid item xs={12} className="RepairActionContent">{moment(action.timeLineDate).format('M/D h:mm A')}</Grid>
                    </Grid>
                break;
            case 'Closed':
                component =
                    <Grid item container justify='center' alignItems='center' style={{ paddingTop: '1rem' }}>
                        <Grid item xs={12} className="ActionClosed">{'Closed Date'}</Grid>
                        <Grid item xs={12} className="RepairActionContent">{moment(action.timeLineDate).format('M/D h:mm A')}</Grid>
                    </Grid>
                break;
            case 'canceled':
                component =
                    <Grid item container justify='space-around' alignItems='center' style={{ paddingTop: '1rem' }}>
                        <Grid item xs={12} className="RepairActionSubTitle">{'Canceled by'}</Grid>
                        <Grid item container xs={12} className="RepairActionContent" justify='flex-start' alignItems='center'>
                            <Grid item xs={4} style={{}}>
                                <img
                                    className="RepairsActionImage"
                                    src='https://engage360.s3.amazonaws.com/Residents/profile.png'
                                    alt={action.userName + ' profile picture'}
                                />
                            </Grid>
                            <Grid item xs={7} style={{}}>{action.userName}</Grid>
                        </Grid>
                        <Grid item xs={12} className="RepairActionContent">{moment(action.timeLineDate).format('M/D h:mm A')}</Grid>
                    </Grid>
                break;
            default:
                break;

        }
        return (
            component
        );
    };

    //#endregion
    render() {

        const repairData = (this.props.tableData && this.props.tableData.length)? this.props.tableData.find(r => String(r._id) === String(this.state.repairSelectedForDetails._id)): undefined


        const resident = (this.state.repairSelectedForDetails && this.state.repairSelectedForDetails.resident) ? this.state.repairSelectedForDetails.resident : undefined;
        const item = (repairData)? repairData:  (this.state.repairSelectedForDetails) ? this.state.repairSelectedForDetails : undefined;
        const repairSelected = this.state.repairSelectedForDetails? this.state.repairSelectedForDetails : undefined;
        const isCommonArea = (repairSelected && repairSelected.isCommonArea)? repairSelected.isCommonArea : false;

        return (
            <main style={{ padding: '10px', paddingTop: '20px' }}>
                <div >
                    <Grid item container xs={12} justify='center'>
                        <Grid item container xs={11} id='Repairs_details'>
                            <Grid item container xs={12} justify='space-between' >
                                <Grid item container xs={12} md={5} lg={3} className="RepairsSection">
                                    <this.RenderInnerResidentComponent resident={resident} isCommonArea={isCommonArea} />
                                </Grid>
                                <Grid item container xs={12} md={5} lg={3} className="RepairsSection">
                                    <this.RenderInnerLocationComponent item={item} />
                                </Grid>
                                <Grid item container xs={12} md={12} lg={5} className="RepairsSection">
                                    <this.RenderInnerRepairRequestComponent item={item} />
                                </Grid>
                                <Grid item container xs={12} className="RepairsSectionTimeline">
                                    <this.RenderInnerTimeLineComponent item={item} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </main>
        )
    }
}

function mapStateToProps(state, dispatch) {

    const repairData = (state.repairReducer && state.repairReducer.repairData) ? state.repairReducer.repairData : [];
    // const itemsIconsData = (state.itemReducer.itemsIconsData && state.itemReducer.itemsIconsData.icons)? state.itemReducer.itemsIconsData.icons : [];

    return {
        tableData: repairData,
        // itemsIconsData: itemsIconsData,
    }
}


RepairDetails = reduxForm({
    form: 'RepairDetailsForm',
    enableReinitialize: true,
})(RepairDetails);

export default connect(mapStateToProps, { AddViewWorkOrder, getAllRepairs })(RepairDetails);

